// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__VpS8Z","row":"ProcedureTreatmentSummary_row__e09e_"};